import React from 'react'
import parse from 'html-react-parser'
import { Grid, Paper, Typography, Button } from '@material-ui/core'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import Loader from '../Loader/Loader'

import { useStyles } from './AddEssayQuestionStyles'

const EssayTile = ({
  questionIndex,
  editQuestion,
  addQuestion,
  question,
  isPublished,
  isQuizStarted,
  quizStartTime,
  deleteQuestion,
  handleDelete,
  isWriteAllowed,
  handleChange,
}) => {
  const classes = useStyles()

  return (
    <Grid item container spacing={2} xs={12}>
      <Grid item xs={10} sm={11}>
        <Paper elevation={2} variant="outlined" className={classes.paper}>
          <Grid item xs={12} className={classes.editQuestion}>
            <Grid item container xs={12}>
              <Grid item container xs={7} sm={4} alignItems="center">
                <Typography className={classes.questionIndex}>
                  Question {questionIndex === undefined ? 1 : questionIndex + 1}
                  .
                </Typography>
              </Grid>
              <Grid
                item
                container
                xs={5}
                sm={8}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                {Number.isNaN(editQuestion) &&
                  !addQuestion &&
                  question?.type !== 'essay' && (
                    <Typography
                      variant="h4"
                      style={{ color: '#00B7A4' }}
                      className={classes.tileMarks}
                    >
                      {question?.marks} marks
                    </Typography>
                  )}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} style={{ display: 'flex' }}>
                <div className={classes.question}>
                  {parse(question?.question)}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {isWriteAllowed && (
        <Grid item xs={2} sm={1}>
          {editQuestion !== questionIndex && !addQuestion && (
            <>
              <Button
                color="secondary"
                className={classes.editButton}
                variant="outlined"
                onClick={handleChange}
                disabled={isQuizStarted(quizStartTime)}
              >
                <EditOutlinedIcon data-testid="question-testId" />
              </Button>
              {(!isQuizStarted(quizStartTime) || !isPublished) &&
                (deleteQuestion?.isLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingTop: '12px',
                    }}
                  >
                    <Loader size={30} />
                  </div>
                ) : (
                  <Button
                    disabled={isQuizStarted(quizStartTime)}
                    className={classes.deleteButton}
                    variant="outlined"
                    onClick={() => handleDelete()}
                    data-testid="delete-button-on-click"
                  >
                    <DeleteOutlineOutlinedIcon />
                  </Button>
                ))}
            </>
          )}
        </Grid>
      )}
    </Grid>
  )
}

export default EssayTile
